export default __webpack_public_path__ + "static/media/1569.2a2f66ef.png";